import React, {useEffect, useState} from "react";
import dynamic from 'next/dynamic'
import {useAbandonedCountriesCheckState} from "../../components/store/AbandonedCountriesCheckState";
import {useSymbolsGlobalState} from "../../components/store/SymbolsMetaDataState";
import {
    addMetadataToForeignMarketResponse,
    getSymbolFromFullSymbol,
    parseIranMarketApiResponse
} from "../../util/DominantUtil";
import Box from "../../components/box/Box";
import {fetchStockSummary} from "../../util/APIUtils";
import StockSummary from "../../components/summary/StockSummary";
import {processData} from "../../components/store/ProcessData";
import {makeStockHelmet} from "../../util/SEOUtil";

const HistoryChartDynamic = dynamic(() => import('../../components/stock/HistoryChart'), {ssr: false})
const WebSocketNoSSR = dynamic(import('react-websocket'), {
    ssr: false
})

export default function Stock({stockSummary, metadata}) {
    const [stockData, setStockData] = useState(stockSummary);
    // const wsAddress = stockSummary.s && `wss://stream.binance.com:443/ws/${stockSummary.s.toLowerCase()}@ticker`;
    const [symbolsGlobalCache, refreshSymbolsCache] = useSymbolsGlobalState(state => [state.cache, state.refreshCache]);
    const cryptoIsAccessibleInThisCountry = useAbandonedCountriesCheckState(state => state.cryptoIsAccessibleInThisCountry);

    useEffect(() => {
        refreshSymbolsCache();
    }, [symbolsGlobalCache])

    function setLiveData(data) {
        const newStockSummary = JSON.parse(data)
        const cryptoWithMetadata = addMetadataToForeignMarketResponse(newStockSummary, metadata);
        setStockData({ ...stockData, ...cryptoWithMetadata });
    }

    function Iframe(props) {
        const iframe = `<iframe id="tradingview_ac907" src="https://s.tradingview.com/widgetembed/?frameElementId=tradingview_ac907&amp;symbol=BINANCE%3A${getSymbolFromFullSymbol(stockSummary.s)}&amp;interval=1&amp;hidesidetoolbar=0&amp;symboledit=1&amp;saveimage=1&amp;toolbarbg=f1f3f6&amp;studies=%5B%5D&amp;theme=dark&amp;locale=fa&amp;style=1&amp;timezone=Asia%2FTehran&amp;hideideasbutton=1&amp;withdateranges=1&amp;studies_overrides=%7B%7D&amp;overrides=%7B%7D&amp;enabled_features=%5B%5D&amp;disabled_features=%5B%5D&amp;utm_source=bahabin.com&amp;utm_medium=widget&amp;utm_campaign=chart&amp;utm_term=BINANCE%3AADAUSDT" style="width: 100%; height: 100%; margin: 0 !important; padding: 0 !important;" allowtransparency="true" scrolling="no" allowfullscreen="" frameborder="0"></iframe>`;
        return (<div className="col-xl-12 col-lg-12 col-md col-sm py-3" style={{
            width: '100%',
            minHeight: '600px',
            padding: '0 !important'
        }} dangerouslySetInnerHTML={{__html: iframe}}/>);
    }

    const market = "ارز دیجیتال"

    return (
        <Box disableHeader={true} loaded={true}
             height={900}
             leftBoxClassName={'w-100 bg-white'}>

            {stockSummary && makeStockHelmet({
                s: getSymbolFromFullSymbol(stockSummary.s),
                market: market,
                assetType: market,
                faN: stockSummary.faN
            })}

            <div className="stock-box p-20px">
                <div className="row">
                    <div className="col-xl-5 col-lg-5 col-md col-sm">
                        <StockSummary data={stockData}/>
                    </div>
                    <div className="col-xl-7 col-lg-7 col-md col-sm">
                        <HistoryChartDynamic symbol={getSymbolFromFullSymbol(stockSummary.s)}/>
                    </div>
                </div>
                <div className="row">
                    {Iframe()}
                </div>
            </div>
        </Box>
    );
}

export async function getServerSideProps(context) {
    const {stock} = context.query;
    const response = await fetchStockSummary("CRYP:" + stock);
    const metadata = processData();

    if (response.length === 0) {
        return {
            notFound: true,
        };
    }

    const stockSummary = addMetadataToForeignMarketResponse(response, metadata)[0];

    return {
        props: {
            stockSummary,
            metadata
        },
    };
}
